<template>
    <section class="legacy-photo-disabled" role="status">
        <h2>旧选片入口已停用</h2>
        <p>请前往摄影预约列表查看本人订单和待出片进度。</p>
        <button type="button" @click="$router.push({ name: 'photographyAppointments' })">前往摄影预约列表</button>
    </section>
</template>
<script>
export default { name: 'LegacyPhotoDisabled' };
</script>
<style scoped>
.legacy-photo-disabled { max-width:760px; margin:48px auto; padding:32px; line-height:1.8; }
.legacy-photo-disabled button { padding:10px 18px; cursor:pointer; }
</style>
